import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";
import { mapPinIdGetter } from "@app/util/map/idGetters";

const routeDetailsState = (state: RootState) => state.scene.route.routeDetails.map;

export const isGoToLocationPopoverVisible = createSelector(
  routeDetailsState,
  ({ goToLocationPopoverVisible }) => goToLocationPopoverVisible
);

export const getRouteViewState = createSelector(routeDetailsState, ({ viewState }) => viewState);
export const getRouteViewport = createSelector(routeDetailsState, ({ viewport }) => viewport);
export const getRouteEntries = createSelector(
  routeDetailsState,
  ({ categorizedMapEntries }) => categorizedMapEntries
);
export const getRouteExternalEntries = createSelector(
  routeDetailsState,
  ({ categorizedExternalMapEntries }) => categorizedExternalMapEntries
);

export const isRoutePinsLoading = createSelector(
  routeDetailsState,
  ({ pinsLoading }) => pinsLoading
);
export const getRoutePinsCount = createSelector(routeDetailsState, ({ pinsCount }) => pinsCount);

export const getRouteAnnotation = createSelector(routeDetailsState, ({ annotation }) => annotation);
export const getRoutePinHover = createSelector(routeDetailsState, ({ pinHover }) => pinHover);
export const getRouteHoveredPin = createSelector(
  routeDetailsState,
  ({ categorizedExternalMapEntries, categorizedMapEntries, pinHover }) => {
    if (!pinHover) {
      return undefined;
    }
    return (
      categorizedMapEntries.multiPins.find(({ id }) => id === pinHover) ??
      categorizedMapEntries.entities.find((pin) => mapPinIdGetter(pin) === pinHover) ??
      categorizedExternalMapEntries.multiPins.find(({ id }) => id === pinHover) ??
      categorizedExternalMapEntries.entities.find((pin) => mapPinIdGetter(pin) === pinHover)
    );
  }
);
export const getRouteSelectedPin = createSelector(
  routeDetailsState,
  ({ selectedPin }) => selectedPin
);

export const getRouteFocusedStop = (state: RootState) =>
  state.scene.route.routeDetails.map.focusedStop;

export const getRouteCategorizedMapEntries = createSelector(
  routeDetailsState,
  ({ categorizedMapEntries }) => categorizedMapEntries
);
export const getRouteCategorizedExternalMapEntries = createSelector(
  routeDetailsState,
  ({ categorizedExternalMapEntries }) => categorizedExternalMapEntries
);

export const getRouteStopVisuals = createSelector(
  routeDetailsState,
  ({ stopVisuals }) => stopVisuals
);
